const NAME_SPACE = 'AdvertisementComponent';

export { NAME_SPACE };
